import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {default as Tooltip} from 'components/Tooltip';
import CopyToClipboard from 'react-copy-to-clipboard';
import classnames from 'classnames';
import numeral from 'numeral';
import ImagePreviewModal from './ImagePreviewModal';

const ORIGINAL = 'ORIGINAL';
const OPTIMIZED = 'OPTIMIZED';
const SIZE_FORMAT = '0 b';
const POPOVER_TIMEOUT = 2000;  // in ms

const ImagePreview = createReactClass({
  propTypes: {
    kitToken: PropTypes.string.isRequired,
    workingSetImage: ImmutablePropTypes.record,
  },

  getInitialState() {
   return {
      showAssetType: OPTIMIZED,
      showLargerImage: false,
      imagesLoaded: [],
      cdnLinkCopied: false,
    };
  },

  handleShowOptimized() {
    this.setState({showAssetType: OPTIMIZED});
  },

  handleShowOriginal() {
    this.setState({showAssetType: ORIGINAL});
  },

  widthAndHeight() {
    if (this._image) {
      return [this._image.naturalWidth, this._image.naturalHeight];
    } else {
      return [null, null];
    }
  },

  handleImageLoaded() {
    let imagesLoaded = [...this.state.imagesLoaded];

    imagesLoaded.push(this.state.showAssetType);

    this.setState({
      imagesLoaded,
    });
  },

  handleCdnUrlClicked(event) {
    event.target.select();
  },

  handleCdnUrlCopied() {
    const disable = () => this.setState({cdnLinkCopied: false});

    this.setState({cdnLinkCopied: true}, () => {
      setTimeout(disable, POPOVER_TIMEOUT);
    });
  },

  handleImageClicked(event) {
    event.preventDefault();

    this.setState({
      showLargerImage: true,
    });
  },

  handleShowLargerImageClosed() {
    this.setState({
      showLargerImage: false,
    });
  },

  render() {
    const {workingSetImage} = this.props;
    const {showAssetType, imagesLoaded, cdnLinkCopied} = this.state;
    const showOptimized = showAssetType === OPTIMIZED;
    const showOriginal = showAssetType === ORIGINAL;
    const imageUrl = (showOptimized) ? workingSetImage.optimizedUrl : workingSetImage.originalUrl;
    const percentLeft = workingSetImage.optimizedSize / workingSetImage.originalSize * 100
    const percentSaved = 100 - percentLeft;
    const imageLoaded = ~imagesLoaded.indexOf(showAssetType);
    const [width, height] = this.widthAndHeight();
    const dimensions = (imageLoaded) ? `${width} x ${height}` : 'Loading...';
    const cdnLinkCopiedPopover = (cdnLinkCopied) ? <Tooltip noIcon={true} content="Link Copied!" /> : null;

    return (
      <div>
        <ImagePreviewModal isOpen={this.state.showLargerImage} onClosed={this.handleShowLargerImageClosed} workingSetImage={workingSetImage} />
        <div className="clearfix asset-uploaded-preview">
          <ul className="nav nav-tabs-inline m-xs-b-md">
            <li className={classnames("nav-item", {active: showOptimized})}>
              <a onClick={this.handleShowOptimized} className="nav-link" href="#">Optimized</a>
            </li>
            <li className={classnames("nav-item", {active: showOriginal})}>
              <a onClick={this.handleShowOriginal} className="nav-link" href="#">Original</a>
            </li>
          </ul>

          <div className="bg-img-checkered text-xs-center">
            <a onClick={this.handleImageClicked} href="#" className="asset-preview-large-toggle block link-dashed-none">
              <i className="asset-preview-large-toggle-icon ficon ficon-3x ficon-search text-white br-circle p-xs-a-lg block" title="View a larger version"></i>
              <img onLoad={this.handleImageLoaded} ref={(r) => this._image = r} className="asset-uploaded-preview-display" src={imageUrl} alt={workingSetImage.name} />
            </a>
          </div>
        </div>

        <div className="image-performance bg-gray-lighter">
          <div className="image-performance-value br-r bg-primary" style={{width: `${percentLeft}%`}}></div>
        </div>

        <table className="table table-condensed m-xs-t-md text-muted">
          <tbody>
            <tr className="asset-size">
              <th scope="row" className="text-nowrap">Original Size</th>
              <td>
                <span>{numeral(workingSetImage.originalSize).format(SIZE_FORMAT)}</span>
              </td>
            </tr>
            <tr className="asset-size">
              <th scope="row" className="text-nowrap">Optimized Size</th>
              <td>
                <span className="text-primary">{numeral(workingSetImage.optimizedSize).format(SIZE_FORMAT)}</span> <strong className="text-primary font-weight-normal">({numeral(percentSaved).format('0')}% saved)</strong>
              </td>
            </tr>
            <tr className="asset-dimensions">
              <th scope="row" className="text-nowrap">Dimensions</th>
              <td>
                {dimensions}
              </td>
            </tr>
            <tr className="asset-history">
              <th scope="row" className="text-nowrap">Last Edited</th>
              <td>
                {workingSetImage.updatedAt.fromNow()}
              </td>
            </tr>
            <tr className="asset-cdn-url">
              <th scope="row" className="text-nowrap">
                <span className="m-xs-t-sm block">CDN URL</span>
              </th>
              <td className="has-tooltip p-xs-r-0 p-xs-l-md">
                <div className="gg">
                    <div className="gg-col p-xs-r-md">
                      <input defaultValue={workingSetImage.publishedUrl} onClick={this.handleCdnUrlClicked} className="table bg-white form-control-static p-xs-a-0 br-r-0 block b-a-0 text-truncate" />
                    </div>
                    <div className="gg-col min-width has-tooltip">
                      {cdnLinkCopiedPopover}

                      <CopyToClipboard text={workingSetImage.publishedUrl} onCopy={this.handleCdnUrlCopied}>
                        <button className="copy-control btn btn-primary btn-sm" title="Copy"><i className="ficon ficon-copy"></i></button>
                      </CopyToClipboard>
                    </div>
                </div>
              </td>
            </tr>
            <tr className="asset-use">
              <th scope="row" className="text-nowrap">HTML use</th>
              <td className="p-xs-r-0 p-xs-l-md">
                <div className="well pre bg-gray-dark inset-darkest font-family-monospace m-xs-b-xs p-xs-y-sm text-xs-left text-sm">
                  <div className="code code-highlight word-wrap">
                    <span className="nt">&lt;img</span>&nbsp;<span className="na">src="</span><span className="s">{workingSetImage.publishedUrl}</span><span className="na">"</span>&nbsp;<span className="na">alt=""</span><span className="nt">&gt;</span>
                  </div>
                </div>
                <p className="text-sm m-xs-b-0 text-muted"><strong>Accessibility heads up</strong>: Provide a text equivalent with the alt attribute for your image.</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  },
});

export default ImagePreview;



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/ImagePreview.js